import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button from 'components/common/button';
import { StyledX } from 'components/customer/answer_panel/answer_panel_toggle_button';
import TeamAssistIcon from 'components/lib/icons/team_assist_icon';
import ToggleTeamAssistPanel from 'actions/team_assist/toggle_team_assist_panel';
import { useExecuteAction } from 'components/hooks/connect_hooks';

export default function TeamAssistPanelToggleButton({ isActive, isPanelOpen }) {
  const executeAction = useExecuteAction();
  const onClick = useCallback(() => executeAction(ToggleTeamAssistPanel), [executeAction]);

  const [isHovered, setHovered] = useState(false);
  const onMouseEnter = useCallback(() => setHovered(true), []);
  const onMouseLeave = useCallback(() => setHovered(false), []);

  useEffect(() => {
    setHovered(false);
  }, [isPanelOpen]);

  let content = isActive && isPanelOpen && isHovered ? <StyledX>✕</StyledX> : <StyledIcon height="11" width="11" />;

  return (
    <StyledButtonWrapper onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <StyledButton data-aid="teamAssistPanelToggleButton" isActive={isActive} onClick={onClick}>
        {content}
      </StyledButton>
    </StyledButtonWrapper>
  );
}

TeamAssistPanelToggleButton.propTypes = {
  isActive: PropTypes.bool,
  isPanelOpen: PropTypes.bool,
};

const StyledButton = styled(Button)`
  align-items: center;
  background-color: ${p => (p.isActive ? p.theme.colors.purple400 : p.theme.colors.white)};
  border: 1px solid ${p => p.theme.colors.purple400};
  border-right: none;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 0;
  border-top-left-radius: 50%;
  border-top-right-radius: 0;
  box-shadow: ${p => p.theme.boxShadow.small};
  color: ${p => (p.isActive ? p.theme.colors.white : p.theme.colors.purple400)};
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: 4px;
  width: 24px;
  &:hover {
    background-color: ${p => p.theme.colors.purple500};
    color: ${p => p.theme.colors.white};
  }
`;

const StyledIcon = styled(TeamAssistIcon)`
  color: inherit;
`;

const StyledButtonWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 40px;
  z-index: 6;
`;
